export const CalculateMonth = (time) => {
  const value =
    (new Date().getFullYear() - new Date(time).getFullYear()) * 12 +
    (new Date().getMonth() - new Date(time).getMonth());
  return value;
};
